import { render, staticRenderFns } from "./PeakAUCFit.vue?vue&type=template&id=792beda0&"
import script from "./PeakAUCFit.vue?vue&type=script&lang=js&"
export * from "./PeakAUCFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports